<template>
    <div v-show="show" class="authTable-container">
        <div class="authTableContent">
            <div class="title">
                <p>审核记录</p>
            </div>
            <div class="filter">
                <div class="left">
                    <p class="title"><span>日</span><span>期</span></p>
                    <ul>
                        <li @click="date = 0" :class="{on: date == 0}">今天</li>
                        <li @click="date = 1" :class="{on: date == 1}">昨天</li>
                        <li @click="date = 2" :class="{on: date == 2}">前一周</li>
                    </ul>
                </div>
                <div class="right">
                    <globalFilter ref="globalFilter" />
                </div>
            </div>
            <div class="table">
                <div class="title">
                    <ul>
                        <li style="width: 266px">文章标题</li>
                        <li style="width: 179px">发布平台</li>
                        <li style="width: 88px">编辑</li>
                        <li style="width: 102px">审核人</li>
                        <li style="width: 115px">审核阶段</li>
                        <li style="width: 170px">审核时间</li>
                        <li style="width: 130px">审核结果</li>
                    </ul>
                </div>
                <ul class="content">
                    <li v-for="(item,index) in list" :key="index">
                        <ul>
                            <li style="width: 266px">
                                <p style="width: 220px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.title}}</p>
                            </li>
                            <li style="width: 179px">{{item.platforms}}</li>
                            <li style="width: 88px">{{item.user_name}}</li>
                            <li style="width: 102px">{{item.verify_username}}</li>
                            <li style="width: 115px;padding-left: 13px;">{{item.verify_step}}</li>
                            <li style="width: 170px;color: #B9C3C3;">{{item.raw_add_time}}</li>
                            <li style="width: 130px">
                                <i :class="{success: item.verify_res == '通过', fail: item.verify_res != '通过'}"></i>
                                <span @click="$Dialog({canEdit: false,content: item.remark})" v-show="item.verify_res != '通过'">退回理由</span>
                            </li>
                        </ul>
                    </li>
                </ul>

                <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
            </div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import globalFilter from "@components/globalFilter";
import pages from "@components/pages";

export default {
    components: {
        globalFilter,
        pages
    },
    data() {
        return {
            show: false,
            config: {},
            list: [],
            callback: null,
            showMessage: true,
            type: 'success',
            searchOptions: {},
            date: 0,
            page: {
                pageCount: 0,
                pageSize: 10,
                pageIndex: 1,
                total: 0
            }
        }
    },
    watch: {
        date(to) {
            this.getList()
        }
    },
    methods: {
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            this.show = true;
            this.getList()
        },
        confirm() {
            this.show = false;
            this.callback()
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        },
        getList() {
            let info = {
                date: this.date,
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }

            info = Object.assign({}, info, this.searchOptions);

            common
            .myFetch(apis.newMediaVerifyLog, {data: info, hideLoading: true})
            .then(r => {
                if (r) {
                    console.log(r)
                    this.$set(
                        this.page,
                        "pageCount",
                        common.calculatePage(r.page.row_count - 0, this.page.pageSize)
                    );
                    this.$set(
                        this.page,
                        "total",
                        r.page.row_count
                    );
                    this.list = r.list;
                    this.generateSearchs(r.params.top_search.option.list);
                }
            });
        },
        generateSearchs(data) {
            // 整理搜索栏数据
            const types = data.map(i => {
                return {
                    name: i.title,
                    code: i.key,
                    selected: i.selected
                };
            });

            const filterData = {
                types: types,
                callback: o => {
                this.getSearch(o);
                },
                from: 'auth'
            };
            this.postSearch(filterData);
        },
        getSearch(d) {
            // 接收搜索框数据
            this.searchOptions = d;
            this.page.pageIndex = 1;
            console.log(this.searchOptions)
            this.getList();
        },
        postSearch(data) {
            // 发送搜索框数据
            if(this.$refs.globalFilter){
                this.$refs.globalFilter.getData(data);
            }
            // this.$emit('filterData', data)
        }
    }
}
</script>

<style lang="less">
    .authTable-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .authTableContent {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -555px;
            margin-top: -335.5px;
            width: 1110px;
            height: 671px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 0px;
            box-sizing: border-box;

            &>.title {
                padding-left: 20px;
                padding-right: 20px;
                box-sizing: border-box;

                p {
                    display: flex;
                    font-size: 24px;
                    line-height: 33px;
                    font-weight: bold;
                    color: #050F0F;
                    margin-bottom: 10px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #DCDCDC;
                    box-sizing: border-box;
                }
            }

            &>.filter {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0 30px;
                box-sizing: border-box;
                margin: 15px 0;

                .left {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 54px;
                        font-size: 13px;
                        line-height: 18px;
                        color: #829191;
                        margin-right: 16px;
                    }
                    
                    ul {
                        display: flex;
                        flex-direction: row;
                        align-items: center;    

                        li {
                            padding: 0 26px;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            font-size: 14px;
                            border-radius: 20px;
                            border: none;
                            box-sizing: border-box;
                            margin-right: 10px;
                            user-select: none;
                            cursor: pointer;

                            &.on {
                                color: #41B48C;
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                            }
                        }
                    }
                }
            }

            &>.table {
                display: flex;
                flex-direction: column;

                .title {
                    width: 100%;
                    height: 40px;
                    padding: 0 30px;
                    background: #F9F9F9;
                    box-shadow: 0px 0px 10px 0px rgba(6, 21, 50, 0.05);
                    box-sizing: border-box;

                    ul {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            line-height: 40px;
                            color: #829191;
                        }
                    }
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    height: 410px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 4px;
                    }


                    &>li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        height: 60px;
                        font-size: 14px;
                        line-height: 60px;
                        color: #050F0F;
                        padding: 0 30px;
                        box-sizing: border-box;

                        ul {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            li {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                box-sizing: border-box;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    margin-left: 20px;
                                    margin-right: 20px;

                                    &.success {
                                        background-image: url('./assets/success.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }

                                    &.fail {
                                        background-image: url('./assets/fail.png');
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                span {
                                    font-size: 16px;
                                    font-weight: bold;
                                    color: #41B48C;
                                    text-decoration: underline;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

            .close {
                position: absolute;
                top: 25px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }
        }
    }
</style>